<template>
	<div class="main-content home">
    <h3 class="title">{{username}}，您好欢迎进入项目管理员端~</h3>
  </div>
</template>

<script>
	import p from "../service/public";

  export default {
		name: "Home",
    data(){
		  return{
		    username:'',
      }
    },
    beforeMount() {
      window.addEventListener('resize', this.resizeHeightHandler);//响应式
    },
    mounted() {
      this.resizeHeightHandler();
    },
    methods:{
		  resizeHeightHandler() {
        let htmlHeight = document.documentElement.clientHeight || document.body.clientHeight;
        document.querySelector('.main-content').style.minHeight = (htmlHeight - 110) + 'px'//给内容撑开，让页面更加规整
      },
    },
    destroyed() {
      window.removeEventListener('resize', this.resizeHeightHandler)
    },
    created() {
		  this.username = p.getCookie(p.token.token_role_name);
    }
  }
</script>

<style scoped lang="scss">
.main-content{
  width: 100%;
  .title{
    font-size: 32px;
    padding-top: 250px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue